module.exports = __webpack_public_path__ + "img/serch_loading.a90e737d.gif";